module.exports = __webpack_public_path__ + "img/00040.52402dba.webp";